export default __webpack_public_path__ + "static/media/basc.68afad91.svg";